var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 782,
    height: 618,
    viewBox: "0 0 782 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99,
    filter: "url(#filter0_f_531_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.701 436.329L271.109 401.258C225.514 393.841 189.616 358.365 181.661 312.86C171.351 253.887 210.762 197.71 269.723 187.332L296.681 182.587C313.895 179.558 331.531 179.877 348.624 183.528L508.743 217.731C563.131 229.348 602 277.397 602 333.012V338.27C602 356.694 596.876 374.756 587.202 390.437C566.08 424.668 526.402 442.787 486.701 436.329Z",
    fill: "url(#paint0_linear_531_112)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_112",
    x: 0.0223389,
    y: 0.529297,
    width: 781.978,
    height: 617.092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_531_112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_112",
    x1: 203.232,
    y1: 197.757,
    x2: 379.515,
    y2: 526.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#24E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector3.8ee352158b7759996174161c575b260e.svg";
export { ForwardRef as ReactComponent };